import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { VoucherDeleteComponent } from '../voucher-delete/voucher-delete.component';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { VoucherEdit } from '../../classes';
import { AdminService } from 'src/app/services/admin/admin.service';
import { MessagesService } from 'src/app/services/message/messages.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { EventsService } from 'src/app/services/events/events.service';
import { voucherStatus, voucherCategory,subscriptionType,accountType,planType,duration } from '../../data-tables';


declare var moment: any;

@Component({
  selector: 'app-voucher-edit',
  templateUrl: './voucher-edit.component.html',
  styleUrls: ['./voucher-edit.component.less']
})
export class VoucherEditComponent implements OnInit {
  public voucherEditForm;
  public accountType: any;
  public planType: any;
  @Input() voucher;

  constructor(private ngbModal: NgbModal, private fb: FormBuilder, private admin: AdminService, private msg: MessagesService, private load: NgxSpinnerService,
    private events: EventsService, private activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.initVoucherEdit();
    
  }

  // inits form
  private initVoucherEdit() {
    const data = this.voucher.data;
    const discount = String(data.discount).replace('%', '').trim();
    let expired = moment(data.expired).format('YYYY-MM-DDThh:mm');
    this.accountType = data.account_type;
    this.voucherEditForm = this.fb.group({
    discount: [discount, [Validators.required, Validators.min(0)]],
    count: [data.totalCount, [Validators.required]],
   //   duration: [Number(data.duration), Validators.required],
    isTraining: [data.isTraining === false ? 'false' : 'true', []],
    status: [data.status,[Validators.required]],
    category: [data.category, [Validators.required]],
  //    subscription_type :  [data.subscription_type, [Validators.required]],
    accountType :  [data.account_type, [Validators.required]],
    expired : [expired,[Validators.required]],
    planType: [data.plan_type,[Validators.required]]
    });
  }

  // private get item
  public getItem(item) {
    if (item === 'status') {
      return voucherStatus;
    }
    if (item === 'category') {
      return voucherCategory;
    }
    if (item === 'subscription_type'){
       return subscriptionType;
    }
    if(item === 'accountType'){
      return accountType;
    }
    if(item === 'planType'){
      let plans = planType[this.accountType]
      return plans;
    }
    if(item === 'duration'){
      return duration;
    }
  }

  // trigger delete voucher modal
  public triggerDeleteVoucherModal() {
    const modal = this.ngbModal.open(VoucherDeleteComponent);

    modal.componentInstance.voucherDetails = this.voucher;

    modal.result
      .then((msg) => {
        if (msg.success) {
          const userid = msg.user;

          this.activeModal.close({ user: userid, task: 'close modal', success: true });
        }
      })
      .catch((msg) => {
        console.log(msg);
      });
  }

  // update voucher
  public updateVoucher() {
    // get voucher input
    const id = this.voucher.data.id;
    const discount = String(this.voucherEditForm.value.discount);
    // const duration = String(this.voucherEditForm.value.duration);
    // const subscriptionType = String(this.voucherEditForm.value.subscription_type)
    const isTraining = this.voucherEditForm.value.isTraining === ('false' || null || undefined) ? 'false' : 'true';
    const status = this.voucherEditForm.value.status;
    const category = this.voucherEditForm.value.category;
    const accountType =  this.voucherEditForm.value.accountType;
    const plan_type = this.voucherEditForm.value.planType;

    let count = String(this.voucherEditForm.value.count - this.voucher.data.count);
    const expired = this.voucherEditForm.value.expired;

    const description = {};
    description['plan_type'] = plan_type;
    description['isTraining'] = isTraining;
    description['totalCount'] = this.voucherEditForm.value.count;
    description['account_type'] = accountType;

    // if(plan_type == 'all'){
    //   description['subscription_type'] = subscriptionType;
    //   description['duration'] = duration;
    // }
    // else{
    //   let tempPlan = plan_type.split("_");
    //   description['subscription_type'] = tempPlan[1];
    //   description['duration'] = tempPlan[2];
    // }

    if(count == "0"){
       count = this.voucherEditForm.value.count;
    }
    
    const updateVoucher = new VoucherEdit(id, discount, count, expired,JSON.stringify(description), status, category);
    this.admin.updateVoucher(updateVoucher)
      .then(res => this.success(res, updateVoucher))
      .catch(err => this.error(err));
   }

   // handle success
   private success(msg, voucher) {
     // get voucher id
     const from = this.voucher.from;
     const voucherid = this.voucher.data.id;

     this.msg.success(msg.message);
     this.events.triggerTableReload(voucherid, from, 'update', voucher);
     this.activeModal.close({ user: voucherid, task: 'update', success: true });
  }

  // handle error
  private error(err) {
    this.load.hide();
    this.msg.error(err);
  }

  public updateAccountType(acctype){
    this.accountType = acctype;
  }

  public checkPlanType(plan){
    this.planType = plan;
  }
}
